export default "__VITE_ASSET__DxS4VrpO__"